import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import { get, find } from "lodash";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import isEmail from "validator/lib/isEmail";
import isEmpty from "validator/lib/isEmpty";
import {
  postContact,
  onSaveContactForm,
  onChangeInputType,
  resetContactForm
} from "~/store/contact/contactAction";
import * as hospitalActions from "~/store/hospital/hospitalActions";

import { partnerInfo } from "~/configs/partnerDetails";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const ContactPageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "mobile" */ "~/components/desktop/pages/Contact"
    ),
  loading: LoadableLoading
});
const ContactPageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "desktop" */ "~/components/desktop/pages/Contact"
    ),
  loading: LoadableLoading
});

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listProblem: [
        { id: 0, name: "Chọn vấn đề" },
        { id: 1, name: "Vấn đề chuyên môn" },
        { id: 2, name: "Vấn đề kỹ thuật" },
        { id: 3, name: "Vấn đề khác" }
      ],
      chosenType: 0
    };
  }

  method = {
    handleSelectHospital: event => {
      this.props.selectHospital(Number(event));
    },

    validatorName: (rule, value, callback) => {
      if (value) {
        value = value.toLowerCase();
        value = value.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
        value = value.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
        value = value.replace(/ì|í|ị|ỉ|ĩ/g, "i");
        value = value.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
        value = value.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
        value = value.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
        value = value.replace(/đ/g, "d");
        const patternName = /^[a-zA-Z ]+$/;
        if (patternName.test(value)) {
          callback();
        } else {
          callback("Họ tên chỉ bao gồm chữ cái!");
        }
      } else {
        callback();
      }
      callback();
    },

    validatorEmail: (rule, value, callback) => {
      if (typeof value !== typeof undefined && !!value) {
        const trimValue = (value + "").trim();
        if (!isEmpty(trimValue)) {
          if (!isEmail(trimValue)) {
            // eslint-disable-next-line standard/no-callback-literal
            callback("Vui lòng nhập đúng định dạng email !");
          } else callback();
        } else callback();
      } else callback();
    },

    validatorMobile: (rule, value, callback) => {
      if (value) {
        // eslint-disable-next-line camelcase
        const pattern_mobile = /^((\+?84|0)?(86|96|97|98|32|33|34|35|36|37|38|39|89|90|93|70|79|77|76|78|88|91|94|83|84|85|81|82|92|56|58|99|59))[0-9]{7}$/;
        if (pattern_mobile.test(value)) {
          callback();
        } else {
          // eslint-disable-next-line camelcase
          const pattern_phone = /^0((((28|24)[0-9])|(290|291|299|293|297|292|296|270|294|275|277|273|272|254|251|276|271|252|263|259|261|262|257|269|256|260|255|235|236|234|233|232|239|238|237|229|228|227|226|221|225|220|222|211|210|218|212|215|213|214|207|216|209|219|203|204|205|206))[0-9]{7})$/;
          if (pattern_phone.test(value)) {
            callback();
            // eslint-disable-next-line standard/no-callback-literal
          } else callback("Vui lòng nhập đúng định dạng!");
        }
      } else {
        // eslint-disable-next-line standard/no-callback-literal
        callback("Vui lòng nhập số điện thoại!");
      }
    },

    validatorType: (rule, value, callback) => {
      if (Number(value) === 0) {
        callback("Vui lòng chọn loại vấn đề!");
      } else {
        callback();
      }
    }
  };

  componentDidUpdate() {
    const { data } = this.props;
    if (data.id !== 0) {
      this.props.resetContactForm();
    }
  }

  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <ContactPageMobile {...this.state} {...this.props} {...this.method} />
        ) : (
          <ContactPageDesktop
            {...this.state}
            {...this.props}
            {...this.method}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    hospital: {
      hospitalList: { data: hospitalList },
      selectedHospital
    },
    contact: { contactForm, error, data }
  } = state;
  return {
    device: type,
    hospitalList,
    contactForm,
    selectedHospital,
    error,
    data
  };
};

const mapDispatchToProps = dispatch => ({
  onSaveContactForm: fields => {
    dispatch(onSaveContactForm(fields));
  },
  onChangeInputType: fields => {
    dispatch(onChangeInputType(fields));
  },
  postContact: contact => {
    dispatch(postContact(contact));
  },
  requestHospitalList: () => dispatch(hospitalActions.requestHospitalList()),
  selectHospital: id => {
    dispatch(hospitalActions.selectHospital(id));
  },
  resetContactForm: () => {
    dispatch(resetContactForm());
  }
});

const ContactHelmet = withTitle({
  component: Contact,
  title: `${hospitalName.value} | Liên hệ`
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactHelmet);
